import React, { FC } from 'react';
import { Navigate, NavigateProps, useParams } from 'react-router-dom';

import { i18n } from '../i18n';

import { buildLocalePath, DEFAULT_LOCALE, isSupportedLocale } from './localeConfig';

/**
 * Drop-in replacement for React Router's <Navigate> that automatically
 * prepends /:lang prefix to the `to` prop.
 */
export const LocaleNavigate: FC<NavigateProps> = ({ to, ...rest }) => {
  const params = useParams<{ lang?: string }>();
  const locale = (params.lang && isSupportedLocale(params.lang))
    ? params.lang
    : (i18n.language || DEFAULT_LOCALE);

  const localeTo = typeof to === 'string'
    ? buildLocalePath(to, locale)
    : typeof to === 'object' && to.pathname
      ? { ...to, pathname: buildLocalePath(to.pathname, locale) }
      : to;

  return <Navigate to={localeTo} {...rest} />;
};
